import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import { Common } from 'ws-scripts/modules/common';

import Location from '../components/Location';
import { getLocationAttributes } from '../utils/utility';

import '../global-sass/main.scss';

const locationStatusDisplayList = ['IN_TRANSIT', 'RESERVED', 'OFF_LOT'];

class WidgetContainer extends React.Component {
	render() {
		let shouldDisplay = false;

		const {
			location,
			prefs: {
				alwaysDisplayWidget,
				checkAvailabilityWidget,
				overrideLocation
			},
			widgetInfo
		} = this.props;

		if (
			location &&
			(alwaysDisplayWidget === 'true' ||
				locationStatusDisplayList.find((x) => x === location.status))
		) {
			shouldDisplay = true;
		}

		if (
			overrideLocation === 'true' &&
			alwaysDisplayWidget !== 'true' &&
			location.status === 'OFF_LOT'
		) {
			shouldDisplay = false;
		}

		if (shouldDisplay) {
			return (
				<Common
					render={({ labels, sitemap, prefs }) => {
						return (
							<Location
								displayObj={getLocationAttributes(
									location,
									checkAvailabilityWidget,
									labels,
									sitemap,
									overrideLocation,
									widgetInfo,
									prefs
								)}
							/>
						);
					}}
				/>
			);
		}

		return null;
	}
}

WidgetContainer.propTypes = {
	prefs: PropTypes.shape({
		alwaysDisplayWidget: PropTypes.string.isRequired,
		checkAvailabilityWidget: PropTypes.string.isRequired,
		overrideLocation: PropTypes.string.isRequired
	}).isRequired,
	location: PropTypes.shape({
		status: PropTypes.string.isRequired,
		accountId: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired
	}).isRequired,
	widgetInfo: PropTypes.shape({
		pageAlias: PropTypes.string.isRequired,
		vehicleId: PropTypes.string.isRequired,
		vehicleCategory: PropTypes.string.isRequired,
		vehicleAccountId: PropTypes.string.isRequired,
		selectedAccountId: PropTypes.string.isRequired
	}).isRequired
};

const mapStateToProps = (state) => {
	return {
		prefs: state.prefs,
		location: state.location,
		widgetInfo: state.widgetInfo
	};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
